import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';

export default function WorkshopAlertCard({ alert }) {
    const { t } = useTranslation();

    const isRead = alert.status === 'read';
    const createdAt = new Date(alert.created_at).toLocaleString();
    const photosCount = alert.photos?.length ?? 0;

    return (
        <Card sx={{ width: '100%' }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="h6" component="div">
                        {alert.asset_label}
                    </Typography>
                    <Chip
                        icon={isRead ? <CheckCircleIcon /> : <HourglassBottomIcon />}
                        label={isRead ? t('Received') : t('Pending')}
                        color={isRead ? 'success' : 'warning'}
                        size="small"
                    />
                </Box>

                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    {alert.cause}
                </Typography>

                {photosCount > 0 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
                        <PhotoCameraIcon fontSize="small" color="action" />
                        <Typography variant="caption" color="text.secondary">
                            {photosCount} {photosCount === 1 ? t('Photo') : t('Photos')}
                        </Typography>
                    </Box>
                )}

                <Typography variant="caption" color="text.disabled">
                    {createdAt}
                </Typography>
            </CardContent>
        </Card>
    );
}